import { DrawerItemConfig } from '@/components/GlobalNavigationDrawer/lib/types';
import { useGlobalDrawerItems } from '@/components/GlobalNavigationDrawer/lib/useGlobalDrawerItems';
import { useNavigationDrawerItems } from '@/components/NavigationDrawer/NavigationDrawer';
import { FeatureFlag } from '@/types/featureFlag';
import { useFeatureFlagEnabled } from '@/utils/useFeatureFlagEnabled';
import { ReactNode } from 'react';

type ActiveDrawerItemsProps = {
    children: (items: DrawerItemConfig[]) => ReactNode;
};

const GlobalDrawerItems = ({ children }: ActiveDrawerItemsProps) => (
    <>{children(useGlobalDrawerItems())}</>
);

const LegacyDrawerItems = ({ children }: ActiveDrawerItemsProps) => (
    <>{children(useNavigationDrawerItems())}</>
);

/**
 * Renders its children with the items of the navigation drawer the user sees. Only that
 * drawer's items are loaded.
 */
export const ActiveDrawerItems = ({ children }: ActiveDrawerItemsProps) => {
    const hasGlobalNavigationV2 = useFeatureFlagEnabled(FeatureFlag.GLOBAL_NAVIGATION_V2);

    return hasGlobalNavigationV2 ? (
        <GlobalDrawerItems>{children}</GlobalDrawerItems>
    ) : (
        <LegacyDrawerItems>{children}</LegacyDrawerItems>
    );
};
